import AuthService from "../../utilities/services/auth.service";

import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";
import { ARAgingDetailsWrapper } from "../../components";

export default function ARAgingSummaryPage() {
  const organization = AuthService.getOrg()[0];

  return (
    <ModalProvider>
      <ARAgingDetailsWrapper organization={organization} />
    </ModalProvider>
  );
}
